import { createClient } from '@supabase/supabase-js';

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Guard: createClient(undefined, undefined) throws synchronously at module-init
// time and crashes the entire JS bundle → white screen. This happens on Vercel
// when REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY are not set under
// Settings → Environment Variables (Build scope). Placeholder strings prevent
// the crash; network requests will fail with auth errors instead of a blank page.
if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '[ImmoHQ] Supabase env vars missing. ' +
    'Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in ' +
    'Vercel → Settings → Environment Variables (make sure "Build" is checked).'
  );
}

export const supabase = createClient(
  supabaseUrl     || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder'
);
